import React from 'react';
import IconInfo from '@creditflowresearch/uilib/Icon/IconInfo';

import styles from './styles.module.scss';

const DesktopOnlyCaption = () => (
  <div className={ styles.desktopOnlyCaption }>
    <IconInfo className={ styles.desktopOnlyIcon } />
    Currently available on Desktop
  </div>
);

export default DesktopOnlyCaption;
